<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <div class="site-under-construction" role="status" aria-live="polite">
    <h1 class="site-under-construction__title">{{ t('siteUnderConstruction.title') }}</h1>
    <p class="site-under-construction__body">{{ t('siteUnderConstruction.body') }}</p>
    <nav class="site-under-construction__actions" aria-label="Staff access">
      <RouterLink class="site-under-construction__link site-under-construction__link--primary" to="/account">
        {{ t('siteUnderConstruction.accountLink') }}
      </RouterLink>
      <a class="site-under-construction__link" href="/admin/">{{ t('siteUnderConstruction.adminLink') }}</a>
    </nav>
  </div>
</template>

<style scoped>
.site-under-construction {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  min-height: 100vh;
  width: 100%;
  padding: 2rem 1.5rem;
  background-color: var(--color-bg);
  font-family: inherit;
}

.site-under-construction__title {
  margin: 0;
  max-width: 36rem;
  text-align: center;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.35;
  color: var(--color-text);
}

.site-under-construction__body {
  margin: 0;
  max-width: 36rem;
  text-align: center;
  font-size: 0.9375rem;
  font-weight: 500;
  line-height: 1.5;
  color: var(--color-text-muted);
}

.site-under-construction__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1rem;
  align-items: center;
  justify-content: center;
  margin-top: 0.25rem;
}

.site-under-construction__link {
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--color-primary);
  text-decoration: underline;
  text-underline-offset: 0.15em;
}

.site-under-construction__link:hover {
  text-decoration-thickness: 2px;
}

.site-under-construction__link--primary {
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  background-color: var(--color-primary);
  color: #fff;
  text-decoration: none;
}

.site-under-construction__link--primary:hover {
  filter: brightness(1.05);
  text-decoration: none;
}
</style>
